import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../ui/card";
import { Button } from "../ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { getHhbTemplates, updateHhbTemplate, resetHhbTemplate } from "../../lib/api";

export default function HhbTemplatesTab() {
  const [templates, setTemplates] = useState([]);
  const [sel, setSel] = useState("");
  const [text, setText] = useState("");
  const [saving, setSaving] = useState(false);

  const load = async () => {
    try {
      const { data } = await getHhbTemplates();
      setTemplates(data);
      if (!sel && data.length) { setSel(data[0].key); setText(data[0].text); }
      else { const t = data.find((x) => x.key === sel); if (t) setText(t.text); }
    } catch { toast.error("Failed to load templates"); }
  };
  useEffect(() => { load(); }, []); // eslint-disable-line

  const pick = (k) => { setSel(k); const t = templates.find((x) => x.key === k); setText(t ? t.text : ""); };
  const current = templates.find((x) => x.key === sel);

  const save = async () => {
    setSaving(true);
    try { await updateHhbTemplate(sel, text); toast.success("Template saved"); await load(); }
    catch { toast.error("Save failed"); }
    setSaving(false);
  };
  const reset = async () => {
    try { await resetHhbTemplate(sel); toast.success("Reset to default"); await load(); }
    catch { toast.error("Reset failed"); }
  };

  return (
    <Card data-testid="hhb-templates-tab">
      <CardHeader>
        <CardTitle>HHB Letter Templates</CardTitle>
        <CardDescription>Edit the wording of the Hazing/Harassment/Bullying notification letters. Keep the {`{{variables}}`} in place — they are filled in per student/recipient. Reset any letter to the default wording at any time.</CardDescription>
      </CardHeader>
      <CardContent className="space-y-3">
        <div className="flex items-center gap-2 flex-wrap">
          <Select value={sel} onValueChange={pick}>
            <SelectTrigger className="w-80" data-testid="hhb-template-select"><SelectValue /></SelectTrigger>
            <SelectContent>
              {templates.map((t) => <SelectItem key={t.key} value={t.key}>{t.label}{t.is_default ? "" : " (edited)"}</SelectItem>)}
            </SelectContent>
          </Select>
          {current && !current.is_default && <span className="text-xs text-amber-600">Customized</span>}
        </div>
        <textarea rows={16} value={text} onChange={(e) => setText(e.target.value)}
          className="w-full text-sm border rounded px-3 py-2 font-mono" data-testid="hhb-template-text" />
        <div className="flex gap-2">
          <Button onClick={save} disabled={saving} className="bg-[#00305E] hover:bg-[#00305E]/90" data-testid="hhb-template-save">{saving ? "Saving…" : "Save Template"}</Button>
          <Button variant="outline" onClick={reset} data-testid="hhb-template-reset">Reset to Default</Button>
        </div>
      </CardContent>
    </Card>
  );
}
